<div *ngIf="item !== undefined">
  <p>Id: {{ item?.getId() || 'MISSING-ID' }}</p>
  <ngx-json-viewer class="ngx-json-viewer--ellipsis" [depth]="2" [expanded]="true" [json]="jsonValue"></ngx-json-viewer>
</div>
